<template>
	<!-- 充值页面 -->
	<div class="invest_wrap">
		<!-- 顶部导航栏 -->
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)"></div>
			<div class="big_tit">{{ $t('invest.recharge') }}</div>
		</div>

		<!-- 余额卡片 -->
		<div class="balance_card">
			<div class="balance_header">
				<span class="balance_label">{{ $t('invest.availableBalance') }}</span>
				<van-icon :name="eye ? 'eye' : 'closed-eye'" @click="eye = !eye" class="eye_icon" />
			</div>
			<div class="balance_amount">
				<!-- <span class="currency">{{ $t('utils.moneyMark') }}</span> -->
				<span class="amount">{{ eye ? balance : '******' }}</span>
			</div>
		</div>

		<!-- 充值金额输入 -->
		<div class="amount_card">
			<div class="card_title">{{ $t('invest.rechargeAmount') }}</div>
			<div class="input_wrap">
				<!-- <span class="input_prefix">{{ $t('utils.moneyMark') }}</span> -->
				<input v-model.trim="data.money" type="number" step="0.01" class="amount_input"
					:placeholder="$t('invest.rechargeAmount')" @input="changeAmount">
			</div>
			<!-- <div class="amount_convert" v-if="actualAmount">{{ actualAmount }}</div> -->
		</div>

		<!-- 支付方式选择 -->
		<div class="payment_card">
			<div class="card_title">{{ $t('invest.paymentMethod') }}</div>
			<div class="payment_list">
				<div v-for="(v, k) in config.payment" :key="k" class="payment_item"
					:class="{ 'active': k + 1 == data.choose }" @click="choose_type(k + 1, v)">
					<div class="payment_icon">
						<img :src="v.logo" />
					</div>
					<div class="payment_name">{{ v.name }}</div>
					<div class="payment_check">
						<van-icon name="success" v-if="k + 1 == data.choose" />
					</div>
				</div>
			</div>
		</div>

		<!-- 提交按钮 -->
		<div class="submit_btn" @click="submit">
			{{ $t('invest.next') }}
		</div>

		<!-- 温馨提示 -->
		<div class="tips_box" v-if="config.min_recharge">
			<div class="tips_title">温馨提示</div>
			<!-- <div class="tips_content">最低充值金额为 {{ $t('utils.moneyMark') }}{{ config.min_recharge }}</div> -->
			<div class="tips_content">最低充值金额为 {{ config.min_recharge }}</div>

		</div>
	</div>
</template>

<script>
/**
 * 充值页面组件
 * 用户选择充值金额和支付方式，跳转到对应的支付页面
 */
import Vue from 'vue';
import { Icon, Toast } from 'vant';
import Fetch from '../../utils/fetch'
import Api from "../../interface/index";

Vue.use(Icon);

export default {
	name: "invest",
	/**
	 * 组件数据
	 * @returns {Object} 数据对象
	 * @returns {boolean} eye - 余额是否可见
	 * @returns {number|string} balance - 账户余额
	 * @returns {Object} data - 充值表单数据
	 * @returns {Object} payment - 当前选中的支付方式
	 * @returns {Object} config - 充值配置信息
	 * @returns {string} actualAmount - 实际到账金额显示文本
	 */
	data() {
		return {
			eye: true,
			balance: 0.00,
			data: {
				choose: '',
				channel: '',
				money: '',
				id: ''
			},
			payment: [],
			config: {},
			actualAmount: '',
		};
	},
	created() {
		this.$parent.footer('user', false);
	},
	mounted() {
		this.start();
	},
	methods: {
		/**
		 * 初始化页面数据
		 * 获取充值配置和账户余额
		 */
		start() {
			Fetch('/user/recharge', {
				...this.data
			}).then((r) => {
				this.balance = r.data.money;
				this.config = r.data;
				this.config.min_recharge = parseInt(this.config.min_recharge);
				// 默认选中第一个支付方式
				if (r.data.payment && r.data.payment.length > 0) {
					this.choose_type(1, r.data.payment[0]);
				}
			});
		},
		/**
		 * 选择支付方式
		 * @param {number} k - 支付方式索引（从1开始）
		 * @param {Object} payment - 支付方式对象
		 */
		choose_type(k, payment) {
			this.data.choose = k;
			this.data.channel = payment.type;
			this.data.id = payment.id;
			this.payment = payment;
			this.changeAmount();
		},
		/**
		 * 提交充值表单
		 * 验证表单并跳转到对应的支付页面
		 */
		submit() {
			// 验证充值金额
			if (!this.data.money || this.data.money < this.config.min_recharge) {
				this.$toast({
					className: "toastName",
					message: this.$t('invest.rechargeAmountLow') + this.config.min_recharge + this.$t('invest.rechargeAmountLow1')
				});
				return false;
			}

			// 验证支付方式
			if (!this.data.channel) {
				this.$toast({
					className: "toastName",
					message: this.$t('invest.paymentMethodEmpty')
				});
				return false;
			}

			// 根据支付方式跳转到对应页面
			const channel = this.data.channel;
			const query = {
				money: this.data.money,
				id: this.data.id
			};

			if (channel == 1) {
				// USDT支付
				this.$router.replace({ path: '/invest/usdt', query });
			} else if (channel == 2) {
				// 支付宝支付
				query.type = channel;
				this.$router.replace({ path: '/invest/alipay', query });
			} else if (channel == 3) {
				// 微信支付
				query.type = channel;
				this.$router.replace({ path: '/invest/wx', query });
			} else if (channel == 4) {
				// 银行卡支付
				this.$router.replace({ path: '/invest/bank', query });
			} else if (channel == 5) {
				// 第三方支付，直接跳转
				Fetch("/user/recharge_type", {
					money: this.data.money,
					id: this.data.id
				}).then((r) => {
					if (r.data.code == 0) {
						window.location.href = r.data.data.qr_code;
					} else {
						this.$toast(r.data.message || '支付跳转失败');
					}
				});
			} else {
				// 其他支付方式
				this.$router.replace({
					path: '/invest/' + channel,
					query: { money: this.data.money }
				});
			}
		},
		/**
		 * 计算实际到账金额
		 * 根据汇率计算并格式化显示金额
		 */
		changeAmount() {
			if (!this.payment.type || !this.data.money) {
				this.actualAmount = '';
				return;
			}

			let num = 2;
			const rate = this.payment.rate;
			const mark = this.payment.mark || '';

			if (this.payment.type == 1) {
				// USDT类型，根据汇率大小调整小数位数
				if (rate > 10000) {
					num = 8;
				} else if (rate > 1000) {
					num = 6;
				} else if (rate > 10) {
					num = 4;
				}
				this.actualAmount = "≈" + (this.data.money / rate).toFixed(num) + " " + mark;
			} else {
				// 其他支付方式
				this.actualAmount = "≈" + mark + (this.data.money / rate).toFixed(num);
			}
		}
	}
};
</script>

<style lang="less" scoped>
/**
 * 充值页面样式
 * 采用卡片式设计，统一视觉风格
 */
.invest_wrap {
	min-height: 100vh;
	background-color: #f5f5f5;
	padding-bottom: 20px;
}

/* 顶部背景 */
.red_top_bg {
	height: 168px;
	background-image: url(../images/user/moneybag/bg.png);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 10;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

/* 余额卡片 */
.balance_card {
	position: relative;
	margin-top: 74px;
	margin-left: 15px;
	margin-right: 15px;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	border-radius: 12px;
	padding: 25px 20px;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	z-index: 11;

	.balance_header {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;

		.balance_label {
			font-size: 14px;
			color: rgba(255, 255, 255, 0.9);
			margin-right: 8px;
		}

		.eye_icon {
			font-size: 20px;
			color: rgba(255, 255, 255, 0.8);
			cursor: pointer;
		}
	}

	.balance_amount {
		text-align: center;

		.currency {
			font-size: 20px;
			color: #fff;
			margin-right: 4px;
		}

		.amount {
			font-size: 36px;
			font-weight: bold;
			color: #fff;
			text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		}
	}
}

/* 通用卡片标题 */
.card_title {
	font-size: 15px;
	color: #333;
	font-weight: 600;
	margin-bottom: 15px;
	display: flex;
	align-items: center;

	&::before {
		content: '';
		display: inline-block;
		width: 3px;
		height: 14px;
		background: #ff5252;
		border-radius: 2px;
		margin-right: 8px;
	}
}

/* 充值金额卡片 */
.amount_card {
	margin: 20px 15px;
	padding: 20px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

	.input_wrap {
		display: flex;
		align-items: center;
		border: 2px solid #f0f0f0;
		border-radius: 8px;
		padding: 12px 15px;
		transition: all 0.3s ease;

		&:focus-within {
			border-color: #ff5252;
			box-shadow: 0 0 0 3px rgba(255, 82, 82, 0.1);
		}

		.input_prefix {
			font-size: 24px;
			font-weight: 600;
			color: #333;
			margin-right: 8px;
		}

		.amount_input {
			flex: 1;
			border: none;
			outline: none;
			font-size: 24px;
			font-weight: 600;
			color: #333;
			background: transparent;

			&::placeholder {
				color: #ccc;
				font-weight: 400;
			}
		}
	}

	.amount_convert {
		margin-top: 10px;
		font-size: 13px;
		color: #666;
		text-align: right;
	}
}

/* 支付方式卡片 */
.payment_card {
	margin: 20px 15px;
	padding: 20px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

	.payment_list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.payment_item {
		display: flex;
		align-items: center;
		padding: 15px;
		border: 2px solid #f0f0f0;
		border-radius: 10px;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			border-color: #ffcdd2;
			background: #fff5f5;
		}

		&.active {
			border-color: #ff5252;
			background: #fff5f5;
			box-shadow: 0 2px 8px rgba(255, 82, 82, 0.15);
		}

		.payment_icon {
			width: 40px;
			height: 40px;
			margin-right: 15px;
			border-radius: 8px;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}

		.payment_name {
			flex: 1;
			font-size: 15px;
			color: #333;
			font-weight: 500;
		}

		.payment_check {
			width: 24px;
			height: 24px;
			display: flex;
			align-items: center;
			justify-content: center;

			.van-icon {
				font-size: 18px;
				color: #ff5252;
				font-weight: bold;
			}
		}
	}
}

/* 提交按钮 */
.submit_btn {
	margin: 25px 15px;
	height: 48px;
	line-height: 48px;
	text-align: center;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	border-radius: 24px;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	cursor: pointer;
	transition: all 0.3s ease;

	&:active {
		transform: scale(0.98);
		box-shadow: 0 2px 8px rgba(255, 82, 82, 0.4);
	}
}

/* 温馨提示 */
.tips_box {
	margin: 20px 15px;
	padding: 15px;
	background: #fff;
	border-radius: 10px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

	.tips_title {
		font-size: 14px;
		color: #333;
		font-weight: 600;
		margin-bottom: 10px;
		display: flex;
		align-items: center;

		&::before {
			content: '';
			display: inline-block;
			width: 3px;
			height: 14px;
			background: #ff5252;
			border-radius: 2px;
			margin-right: 8px;
		}
	}

	.tips_content {
		font-size: 13px;
		color: #666;
		line-height: 1.8;
	}
}
</style>
